import logo from './logo.svg';
import './App.css';
import Book from "./Components/Books/Book";

function App() {
  return (
    <div className="App">
       <Book />
    </div>
  );
}

export default App;
